// extracted by mini-css-extract-plugin
module.exports = {"container":"video-bloc-component_container__81QNb","iFrame":"video-bloc-component_iFrame__3eoQq"};